import React from "react";
import CommonSVGStore from "../../../services/CommonSVGStore";
import { IModalVideoControllerReturn } from "./ModalVideoController";

interface IProps {
  mvc: IModalVideoControllerReturn
}

export const ModalVideo: React.FC<IProps> = (props): JSX.Element => {

  return (
    <>
      {props.mvc.show ? (
        <>
          <div
            id="modal_video"
            className="w-full"
            onMouseDown={(e) => {e.preventDefault(); props.mvc.stopAndClose()}}
          >
            <div
              data-component-name="modal" className="h-full relative z-50" aria-hidden="true" aria-modal="true" role="dialog">
              <div
                className="fixed top-0 left-0 inset-0 transition-opacity bg-gray-300 bg-opacity-70 overflow-y-hidden">
                <div
                  className={`flex justify-center ${props.mvc.isMobile?"p-0":"p-6"} items-center min-h-full`}>
                  <div
                    className="relative transform rounded-3xl transition-all bg-white shadow-xl w-auto max-w-8xl">
                    {(props.mvc.isMobile && props.mvc.isLandscape)?
                    <button
                      className="flex justify-center items-center absolute top-1 right-1 z-50 w-8 h-8 text-white border-[3px] border-white border-solid bg-black hover:bg-gray-600 transition-colors duration-300 rounded-full outline-none lg:focus:outline-offset-0 lg:focus:outline-acqua-500"
                      onClick={(it) => props.mvc.setShow(false)}
                    >
                      {CommonSVGStore.getClose()}
                    </button>:<></>}
                    <div 
                      //className={`${(props.mvc.isMobile && !props.mvc.isLandscape)?"p-0":"p-6"}`}
                      className={`${(props.mvc.isMobile)?"p-0":"p-6"}`}
                    >
                      <div>
                        <video
                          ref={(v) => v}
                          autoPlay = {props.mvc.isAutoPlay}
                          className={`rounded-lg`}
                          //width={"w-auto"}
                          width={props.mvc.width}
                          onEnded={(it) => { props.mvc.setShow(false) }}
                          //onPlay={(it) => { }}
                          controls
                        >
                          <source src={props.mvc.src ? props.mvc.src : ""} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}